class VariantElement extends HTMLElement {
  /* @type {Map<string, HTMLElement>} */
  contentMap = new Map();
  didInit = false;

  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.didInit) {
      this.init();
    }
  }

  init() {
    this.didInit = true;
    for (const contentElement of this.querySelectorAll('[data-variant]')) {
      this.contentMap.set(contentElement.dataset.variant, contentElement);
    }
    
    document.addEventListener('variant:change', (e) => {
      const { variant } = e.detail;
      this.onVariantChange(variant.id + '');
    });

    this.currentVariant = this.getAttribute('data-variant');
    this.innerHTML = '';
    this.onVariantChange(this.currentVariant + '');
    this.removeAttribute('hidden');
  }


  /** @param {string} variantId */
  onVariantChange(variantId) {
    if (this.currentVariant === variantId) {
      return;
    }
    this.currentVariant = variantId;
    const variantContent = this.contentMap.get(variantId) || this.contentMap.get('default');
    if (variantContent) {
      this.innerHTML = '';
      this.appendChild(variantContent);
    }
  }
}

customElements.define('variant-element', VariantElement);
